import React from 'react';
import { makeStyles } from '@material-ui/core';
import classnames from 'classnames';

interface ConfirmationIconProps {
  size?: 'small' | 'large';
  transparentFill?: boolean;
}

const styles = makeStyles(({ spacing, palette }) => ({
  root: {
    lineHeight: 0,
    '& circle': {
      fill: palette.text.contrastText,
    },
  },
  smallSize: {
    '& > svg': {
      width: spacing(5),
      height: spacing(5),
    },
  },
  largeSize: {
    '& > svg': {
      width: spacing(25),
      height: spacing(25),
    },
  },
  transparentFill: {
    color: palette.success.dark,
  },
  opaqueFill: {
    color: palette.success.main,
  },
}));

const ConfirmationIcon = ({ size = 'large', transparentFill = false }: ConfirmationIconProps) => {
  const classes = styles();

  const iconStyles = classnames(classes.root, {
    [classes.smallSize]: size === 'small',
    [classes.largeSize]: size === 'large',
    [classes.transparentFill]: transparentFill,
    [classes.opaqueFill]: !transparentFill,
  });

  return (
    <div className={iconStyles}>
      <svg data-testid="confirmationIcon" width="104px" height="104px" viewBox="0 0 104 104">
        <circle cx="52" cy="52" r="40" />
        <path
          d="M52 104C23.281 104 0 80.719 0 52S23.281 0 52 0s52 23.281 52 52-23.281 52-52 52zm-7.33-41.674L33.488 51.288a3.231 3.231 0 00-2.272-.93c-.853 0-1.67.335-2.272.93a3.139 3.139 0 000 4.485L42.415 69.07a3.24 3.24 0 004.544 0l34.098-33.655a3.139 3.139 0 000-4.485 3.231 3.231 0 00-2.272-.93c-.852 0-1.67.335-2.272.93L44.671 62.326z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </svg>
    </div>
  );
};

export default ConfirmationIcon;
